/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class PatientPortalAccessRequestControllerV2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param patientId
     * @returns boolean
     * @throws ApiError
     */
    public patientPortalAccessRequestControllerV2RevokePatientPortalAccess(
        patientId: number,
    ): Observable<boolean> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/patients/{patientId}/patient-portal/revoke',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns boolean
     * @throws ApiError
     */
    public patientPortalAccessRequestControllerV2InviteToPatientPortal(
        patientId: number,
    ): Observable<boolean> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/patients/{patientId}/patient-portal/invite',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns boolean
     * @throws ApiError
     */
    public patientPortalAccessRequestControllerV2DeleteByPatientId(
        patientId: number,
    ): Observable<boolean> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/v2/patients/{patientId}/patient-portal/cancel-invitation',
            path: {
                'patientId': patientId,
            },
        });
    }
}
